// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_lx-0";
export var fileCarousel = "_lx-2";
export var removeFileButton = "_lx-1";